<template>
  <div
    id="root"
    :style="{
      backgroundSize: 'cover',
      backgroundPosition: 'center',
    }"
  >
    <transition name="fade" mode="out-in">
      <router-view v-if="show" />
    </transition>
  </div>
</template>

<script>
  const appRoot = {
    name: "Root",
    components: {},
    data() {
      return {
        show: true,
        pingWorker: null,
        devMode: process.env.NODE_ENV !== 'production',
      };
    },
    mounted() {
      // logsend disabled until a newrelic version is available
      // this.$logSend.init("DreamWallLogger", this.$router);
      
        this.initPingWorker();
      
    },
    
    beforeDestroy() {
        this.cleanupPingWorker();
      
    },
    
    methods: {
      initPingWorker() {
        try {
          this.pingWorker = new Worker('/webworkers/ping-worker.js');
          
          this.pingWorker.onmessage = (event) => {
            switch (event.data.type) {
              case 'credentials_set':
                if (this.devMode) {
                  console.log('Credenziali NodePing configurate nel worker');
                }

                this.pingWorker.postMessage({ type: 'start_ping' });
                break;
              case 'ping_success':
                if (this.devMode) {
                  console.log('Ping inviato con successo:', new Date(event.data.timestamp).toLocaleTimeString());
                }
                break;
              case 'ping_error':
                if (this.devMode) {
                  console.error('Errore ping:', event.data.error || `Status: ${event.data.status}`, new Date(event.data.timestamp).toLocaleTimeString());
                }
                break;
              case 'interval_started':
                if (this.devMode) {
                  console.log('Ping interval avviato');
                }
                break;
              case 'interval_stopped':
                if (this.devMode) {
                  console.log('Ping interval fermato');
                }
                break;
            }
          };
          
          this.pingWorker.onerror = (error) => {
            console.error('Errore nel ping worker:', error);
          };
          
          const checkId = process.env.VUE_APP_NODEPING_CHECK_ID;
          const checkToken = process.env.VUE_APP_NODEPING_CHECK_TOKEN;
          const pingTimeInSeconds = process.env.VUE_APP_PING_TIME_IN_SECONDS;
          
          if (checkId && checkToken) {
            this.pingWorker.postMessage({
              type: 'init_credentials',
              checkId: checkId,
              checkToken: checkToken,
              pingTimeInSeconds: pingTimeInSeconds,
              pingUrl: `${process.env.VUE_APP_API_URL}/api/nodeping`
            });
          } else {
            console.warn('Credenziali non configurate.');
          }
          
          if (this.devMode) {
            console.log('Ping worker inizializzato');
          }
        } catch (error) {
          console.error('Errore nell\'inizializzazione del ping worker:', error);
        }
      },
      
      cleanupPingWorker() {
        if (this.pingWorker) {
          this.pingWorker.postMessage({ type: 'stop_ping' });
          
          this.pingWorker.terminate();
          this.pingWorker = null;
          
          if (this.devMode) {
            console.log('Ping worker terminato');
          }
        }
      },
    },
  };
  export default appRoot;
</script>

<style lang="scss">
// * { cursor: none; }
html,
body {
  height: 100%;
  overscroll-behavior: none;
}
body {
  min-height: 100%;
  background: url('~~@/assets/img/chalkboard.jpg') no-repeat left top;
  background-size: cover;
}

#root {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height: 100%;
  width: 100%;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.35s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>